import { configureStore } from '@reduxjs/toolkit';
import appStatusReducer from './slices/appStatusSlice';
import authReducer from './slices/authSlice';
import socketReducer from './slices/socketSlice';
import gameReducer from './slices/gameSlice';
import aviatorReducer from './slices/aviatorSocketSlice';
import betReducer from './slices/betSlice';
import profileReducer from "./slices/profileSlice"
import sportsReducer from './slices/sportsSlice';
import betHistoryReducer from './slices/betHistorySlice';
import settleBetsReducer from './slices/settledBetSlice';
import trashBetReducer from './slices/trashedBetSlice';
import  profitLossReducer  from './slices/profitLossSlice';
import userMatchBetsReducer from './slices/UserMatchBetsSlice';
import playerHistoryReducer from './slices/playerHistorySlice';
import casinoResultsReducer from './slices/casinoResultsSlice';
import { websocketMiddleware } from './middleware/websocketMiddleware';
import { aviatorSocketMiddleware } from './middleware/aviatorSocketMiddleware';
import matchReducer from './slices/matchSlice'
import messageReducer from './slices/messageSlice'
import supportReducer from './slices/supportchatSlice'
import chatReducer  from './slices/chatSlice'
import accountReducer from './slices/AccountSlice'
import winnerReducer from './slices/casinoresultwinnerSlice'

export const store = configureStore({
	reducer: {
		appStatus: appStatusReducer,
		auth: authReducer,
		game: gameReducer,
		aviator: aviatorReducer,
		bet: betReducer,
		socket: socketReducer,
		profile: profileReducer,
		sports: sportsReducer,
		betHistory: betHistoryReducer,
		settledBets: settleBetsReducer,
		trashedBets: trashBetReducer,
		profitLoss: profitLossReducer,
		matchBets: userMatchBetsReducer,
		playerHistory: playerHistoryReducer,
		casinoResults: casinoResultsReducer,
		match:matchReducer,
		message:messageReducer,
		support:supportReducer,
		chat:chatReducer,
		account:accountReducer,
		winner:winnerReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({ serializableCheck: false }).concat(websocketMiddleware).concat(aviatorSocketMiddleware),
});

export default store;


